import api from "@/lib/api";

export function trackEvent(event, metadata = {}) {
  api.post("/marketing/track", { event, source: "web", metadata }).catch(() => {});
}
